module.exports = __webpack_public_path__ + "img/icon_settings.924c1d67.svg";